// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-account-settings-branding-display-image-module__image--tgH7n {
  max-height: 70px;
  max-width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/js/account/settings/branding/display-image.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".image {\n  max-height: 70px;\n  max-width: 250px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `src-js-account-settings-branding-display-image-module__image--tgH7n`
};
export default ___CSS_LOADER_EXPORT___;
